'use client'

import { Result, SolidButton } from '@macarongfactory/web-ui'

import { IconAlertCircleYellow } from '@/shared/assets'
import { COMMON_ERROR_DESCRIPTION, COMMON_ERROR_TITLE } from '@/shared/lib'

interface ICarStoryTabErrorProps {
  onRetry: () => void
  /** false면 전체 화면이 아닌 영역 내 인라인 레이아웃으로 표시 */
  fullScreen?: boolean
}

const CarStoryTabError = ({
  onRetry,
  fullScreen = true,
}: ICarStoryTabErrorProps) => {
  return (
    <div
      className={
        fullScreen
          ? 'absolute top-0 left-0 h-dvh w-full flex flex-col items-center justify-center'
          : 'py-dimension-x16 flex w-full flex-col items-center justify-center'
      }
    >
      <Result
        top={
          <Result.Top.Image>
            <IconAlertCircleYellow width={56} height={56} />
          </Result.Top.Image>
        }
        title={<Result.Title text={COMMON_ERROR_TITLE} />}
        description={<Result.Description text={COMMON_ERROR_DESCRIPTION} />}
        button={
          <SolidButton
            variant='neutral-weak'
            text='다시 시도하기'
            size='medium'
            clickable={onRetry}
          />
        }
      />
    </div>
  )
}

export default CarStoryTabError
